module.exports = __webpack_public_path__ + "img/p2.3b968ee1.jpg";